module.exports = __webpack_public_path__ + "static/media/white-logo.802e770d.png";